import { render, staticRenderFns } from "./CaseContent.vue?vue&type=template&id=3ba09a6e"
import script from "./CaseContent.vue?vue&type=script&lang=js"
export * from "./CaseContent.vue?vue&type=script&lang=js"
import style0 from "./CaseContent.vue?vue&type=style&index=0&id=3ba09a6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports